<template>
  <div
    class="ctxs"
    @click.stop="
      () => {
        return false;
      }
    "
  >
    <div class="ctxstop">
      <img
        class="ccloes"
        src="@/assets/menu/mclose.png"
        alt=""
        @click="closeAnPop"
      />
      <p class="ctitle">老版本停服公告</p>
      <div class="ctitle2">
        <span class="ttext">升级送福利</span>
        <img class="ticon" src="@/assets/menu/gift.png" alt="" />
      </div>
    </div>
    <div class="ctxsboo">
      <p class="cinfo1">亲爱的ToDesk用户，您好：</p>
      <p class="cinfo2">
        <span class="te0">为保障大家持续的优质服务体验，我们计划在</span>
        <span class="te1">2024年9月6日—2024年10月31日对4.7.3以下客户端版本进行陆续停服升级</span>
        <span class="te0">，请您及时更新到最新版本，升级将附赠老用户专属大额福利优惠券，感谢您的支持和理解。</span>
      </p>
      <div class="clinkbx">
        <a class="clinkto" :href="BulletinBoardUrl">了解详情</a>
      </div>
      <router-link class="cbtnUpdate" to="/download"
        >立即更新</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    BulletinBoardUrl: {
      default: '',
      type: String
    },
  },
  methods: {
    closeAnPop() {
      this.$emit('closeAnPop');
    }
  },
}
</script>
<style lang="less" scoped>
.ctxs {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  width: 320px;
  .ctxstop {
    position: relative;
    background-image: url("~@/assets/menu/mlayer.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 112px;
    padding-top: 22px;
    box-sizing: border-box;
    padding-left: 20px;
    .ccloes {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 20px;
      height: auto;
    }
    .ctitle {
      font-weight: 600;
      font-size: 28px;
      line-height: 39px;
      color: #006ef0;
    }
    .ctitle2 {
      display: flex;
      align-items: center;
      margin-top: 9px;
      .ttext {
        color: #006ef0;
        font-size: 18px;
        line-height: 20px;
      }
      .ticon {
        margin-left: 3px;
        width: 24px;
        height: auto;
      }
    }
  }
  /deep/ .ctxsboo {
    padding: 20px;
    padding-left: 18px;
    padding-right: 18px;
    .cinfo1 {
      font-size: 14px;
      line-height: 22px;
      color: #131314;
    }
    .cinfo2 {
      margin-top: 6px;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      text-indent: 28px;
      color: #131314;
      .te1 {
        color: #f84646;
      }
    }
    .clinkbx {
      display: flex;
      justify-content: flex-end;
      margin-top: 9px;

      .clinkto {
        color: #1369cc;
        &:active {
          color: #00709f;
        }
      }
    }
    .cbtnUpdate {
      display: block;
      margin-top: 20px;
      width: 100%;
      background: #006ef0;
      border-radius: 6px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      &:active {
        background: #1c87fd;
      }
    }
  }
}
</style>
